import React from 'react';
import './ComparisonCard.less';

/**
 * Loading placeholder shaped like {@link ComparisonCard}. Renders no real
 * ticker/name/price/rating data; the blocks are decorative only so the rating
 * grid keeps its footprint while the selected page request is pending.
 */
const ComparisonCardSkeleton: React.FC = () => (
  <article className="comparison-card comparison-card--skeleton" aria-hidden="true">
    <div className="comparison-card__price">
      <div className="comparison-card__price-row">
        <span className="comparison-skeleton-block comparison-skeleton-block--code" />
        <span className="comparison-skeleton-block comparison-skeleton-block--name" />
      </div>
      <div className="comparison-card__price-row">
        <span className="comparison-skeleton-block comparison-skeleton-block--price" />
        <span className="comparison-skeleton-block comparison-skeleton-block--change" />
      </div>
    </div>
    <span className="comparison-skeleton-block comparison-skeleton-block--chart" />
    <span className="comparison-skeleton-block comparison-skeleton-block--table" />
  </article>
);

export default ComparisonCardSkeleton;
